(function () {
  const root = document.getElementById("svc-diagram");
  if (!root) return;

  const modeButtons = root.querySelectorAll("[data-svc-mode]");
  const panels = root.querySelectorAll("[data-svc-panel]");
  const chips = root.querySelectorAll("[data-svc-variant]");
  const infoBox = root.querySelector("[data-svc-info]");

  const variantCopy = {
    "1": "Size 9, Red",
    "2": "Size 10, Red",
    "3": "Size 11, Blue"
  };

  let activeVariant = null;

  function clearVariant() {
    activeVariant = null;
    chips.forEach(c => c.classList.remove("is-active"));
    if (infoBox) {
      infoBox.hidden = true;
      infoBox.innerHTML = "";
    }
  }

  function setMode(mode) {
    modeButtons.forEach(btn => {
      btn.classList.toggle("is-active", btn.getAttribute("data-svc-mode") === mode);
    });
    panels.forEach(panel => {
      panel.hidden = panel.getAttribute("data-svc-panel") !== mode;
    });
    clearVariant();
  }

  function renderVariant(id) {
    if (!infoBox) return;
    infoBox.hidden = false;
    infoBox.innerHTML =
      "<strong>Variant " + id + " URL</strong> has a canonical tag in its " +
      "<code>&lt;head&gt;</code> pointing to <code>/products/shoe</code>. " +
      "Google follows that signal and consolidates all ranking authority onto " +
      "the base product page. (" + variantCopy[id] + ")";
  }

  modeButtons.forEach(btn => {
    btn.addEventListener("click", function () {
      setMode(this.getAttribute("data-svc-mode"));
    });
  });

  chips.forEach(chip => {
    chip.addEventListener("click", function () {
      const id = this.getAttribute("data-svc-variant");
      if (activeVariant === id) {
        clearVariant();
        return;
      }
      activeVariant = id;
      chips.forEach(c => c.classList.toggle("is-active", c === this));
      renderVariant(id);
    });
  });
})();
